<panel [refresh]="refreshService">
  <h1>Standard panel med scroll</h1>
  <section>
    <custom-input [(value)]="generateNumberOfRows" label="Antal rækker" />
  </section>
  <section>
    <button (click)="generateRows()" [loader]="false">Genererér tilfældige rækker</button>
    <button confirm (click)="appendRows()" [loader]="false">Indsæt tilfældige rækker</button>
    <button reject (click)="removeRows()" [loader]="false">Fjern tilfældige rækker</button>
  </section>
  <list-view dynamic class="scrollable">
    <header>Tekst kolonne</header>
    <header>Dato kolonne</header>
    <header>Nummer kolonne</header>
    <row *listData="let data from testData1" statusColor="color-green-50" [statusTitle]="data.string">
      <column [sortValue]="data.string">{{ data.string }}</column>
      <column [sortValue]="data.date">{{ data.date | customDate: 'shortDate' }}</column>
      <column [sortValue]="data.number">{{ data.number }}</column>
    </row>
  </list-view>
</panel>
<panel width="280">
  <h1>Smalt panel med scroll</h1>
  <list-view class="scrollable">
    <header filterType="contains" filterValue="5">Tekst kolonne</header>
    <header>Dato kolonne</header>
    <header>Nummer kolonne</header>
    <row *listData="let data from testData" statusColor="color-green-50" [statusTitle]="data.string">
      <column [sortValue]="data.string">{{ data.string }}</column>
      <column [sortValue]="data.date">{{ data.date | customDate: 'shortDate' }}</column>
      <column [sortValue]="data.number">{{ data.number }}</column>
    </row>
  </list-view>
</panel>
<panel width="280">
  <h1>Smalt panel med scroll & childs</h1>
  <list-view dynamic class="scrollable" #parentList>
    <header>Tekst kolonne</header>
    <header>Dato kolonne</header>
    <header>Nummer kolonne</header>
    <row *listData="let data from testDataSmall" statusColor="color-green-50" [statusTitle]="data.string" [showCollapseIcon]="true">
      <column [sortValue]="data.string">{{ data.string }}</column>
      <column [sortValue]="data.date">{{ data.date | customDate: 'shortDate' }}</column>
      <column [sortValue]="data.number">{{ data.number }}</column>

      <list-view class="scrollable" [parentList]="parentList">
        <header>Tekst kolonne</header>
        <header>Dato kolonne</header>
        <header>Nummer kolonne</header>
        <row *listData="let data from testDataSmall" statusColor="color-green-50" [statusTitle]="data.string" [showCollapseIcon]="true">
          <column [sortValue]="data.string">{{ data.string }}</column>
          <column [sortValue]="data.date">{{ data.date | customDate: 'shortDate' }}</column>
          <column [sortValue]="data.number">{{ data.number }}</column>
        </row>
      </list-view>
    </row>
  </list-view>
</panel>
<panel width="280">
  <h1>Smalt panel med scroll & dynamiske kolonner</h1>
  <list-view dynamic class="scrollable">
    @for (column of testDynamicColumns; track column) {
      <header>{{ column }}</header>
    }
    <row *listData="let data from testData" statusColor="color-green-50" [statusTitle]="data.string">
      @for (column of testDynamicColumns; track column) {
        <column>{{ data.string }}</column>
      }
    </row>
  </list-view>
</panel>
